import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomeButton () {
  const navigate = useNavigate();
  return (
    <button 
      onClick={() => navigate('/')}
      style={{ 
        position: 'fixed',
        top: 10,
        right: 10,
        zIndex: 1000,
        width: '60px',
        height: '60px',
        background: '#333',
        borderRadius: '50%',
        border: 'none',
        color: 'cyan',
        cursor: 'pointer',
        fontSize: '4rem',
        fontWeight: 'bold',
        padding: 0,
        margin: 0,
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <img src="https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/house.png"
        alt="Home"
        style={{position: 'relative', top: -15}}
        width="30"
      />
    </button>
  );
}
